// Days as people say them: Today, Tomorrow, Friday, or Fri 3 Oct. Posts keep
// the real date and say it relative to the day they go out, so a post planned
// for later never says "tomorrow" about the wrong day.
const pad = (n) => String(n).padStart(2, '0')
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const isoDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
export const isoIn = (days, from = new Date()) => isoDay(new Date(from.getFullYear(), from.getMonth(), from.getDate() + days))
export const parseIso = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '')
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null
}
const daysBetween = (d, ref) => Math.round((d - new Date(ref.getFullYear(), ref.getMonth(), ref.getDate())) / 86400000)

export const dayLabel = (iso, ref = new Date()) => {
  const d = parseIso(iso)
  if (!d) return ''
  const diff = daysBetween(d, ref)
  if (diff === 0) return 'Today'
  if (diff === 1) return 'Tomorrow'
  if (diff > 1 && diff < 7) return DAYS[d.getDay()]
  return `${SHORT[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]}`
}
export const longDate = (iso) => {
  const d = parseIso(iso)
  return d ? `${DAYS[d.getDay()]} ${d.getDate()} ${['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][d.getMonth()]}` : ''
}
export const isPast = (iso, ref = new Date()) => {
  const d = parseIso(iso)
  return !!d && daysBetween(d, ref) < 0
}

// The day a post goes out: when it's planned for, else today
export const postingDay = (post) => (post && post.plannedAt ? new Date(post.plannedAt) : new Date())
// The day a post talks about, as it will read on the day it goes out
export const postDay = (post) => {
  const c = (post && post.content) || {}
  return c.date ? dayLabel(c.date, postingDay(post)) : (c.day || '')
}
// Whose free times a post shows, when they're one stylist's and their name
// is on: the first name, or ''
export const postStylist = (post) => {
  const c = (post && post.content) || {}
  const name = String(c.staffName || '').trim()
  return post && (post.type === 'freeSlots' || post.type === 'oneSlot') && c.staffId && name && c.showName !== false ? name : ''
}
// The day as the post shows it: "Tomorrow with Jess" for one stylist's times
export const dayOnPost = (post) => {
  const day = postDay(post)
  const name = postStylist(post)
  return day && name ? `${day} with ${name}` : day
}

// "2pm", "3:30pm", "14:00" to minutes after midnight; a bare "2:30" in a
// salon means the afternoon
export const minutesOf = (label) => {
  const m = /^\s*(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)?\s*$/i.exec(String(label || ''))
  if (!m) return null
  let h = Number(m[1])
  const min = Number(m[2] || 0)
  const ap = (m[3] || '').toLowerCase()
  if (ap === 'pm' && h < 12) h += 12
  if (ap === 'am' && h === 12) h = 0
  if (!ap && h > 0 && h < 8) h += 12
  return h > 23 || min > 59 ? null : h * 60 + min
}
